/* tslint:disable */
/* eslint-disable */
/**
 * BackOffice — Attributions par plateforme
 * Briques d\'un collaborateur par plateforme (override du compte, sémantique d\'override total avec repli sur le compte) et plafond délégable de la plateforme. Keyé par COLLABORATEUR (abpUserId) : un cabinet de N collaborateurs expose N lignes, et les collaborateurs d\'une corporate (sans ligne Courtier) sont adressables. Surface admin de l\'atelier des rôles + surface gouvernance du Portail Plateforme. 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetBriquesCollaborateurPlateformeCommand
 */
export interface SetBriquesCollaborateurPlateformeCommand {
    /**
     * 
     * @type {Array<string>}
     * @memberof SetBriquesCollaborateurPlateformeCommand
     */
    briques: Array<string>;
}

/**
 * Check if a given object implements the SetBriquesCollaborateurPlateformeCommand interface.
 */
export function instanceOfSetBriquesCollaborateurPlateformeCommand(value: object): value is SetBriquesCollaborateurPlateformeCommand {
    if (!('briques' in value) || value['briques'] === undefined) return false;
    return true;
}

export function SetBriquesCollaborateurPlateformeCommandFromJSON(json: any): SetBriquesCollaborateurPlateformeCommand {
    return SetBriquesCollaborateurPlateformeCommandFromJSONTyped(json, false);
}

export function SetBriquesCollaborateurPlateformeCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetBriquesCollaborateurPlateformeCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'briques': json['briques'],
    };
}

export function SetBriquesCollaborateurPlateformeCommandToJSON(json: any): SetBriquesCollaborateurPlateformeCommand {
    return SetBriquesCollaborateurPlateformeCommandToJSONTyped(json, false);
}

export function SetBriquesCollaborateurPlateformeCommandToJSONTyped(value?: SetBriquesCollaborateurPlateformeCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'briques': value['briques'],
    };
}

